<div class="get-care-now-title-container-mobile">{{title}}</div>
<div class="get-care-now-description-container-mobile">
    <div>{{description}}</div>
</div>
<div *ngIf="virtualUrgentCareOptions != null && virtualUrgentCareOptions.length > 0" class="get-care-now-scroll-container-mobile">
    <app-virtual-urgent-care-option-card-mobile
      *ngFor="let option of virtualUrgentCareOptions; let i = index"
      [providerId]="option.providerId"
      [specialtyId]="option.specialtyId"
      [specialties]="option.specialties"
      [name]="option.providerName"
      [photo]="option.photo"
      [availability]="option.nextAvailability"
      [ngStyle]="i === 0 ? {'margin-left': '16px'} : null">
    </app-virtual-urgent-care-option-card-mobile>
    <div>
        <mat-card class="get-care-now-show-more-card-mobile" appearance="outlined" style="text-align: center;" (click)="showMeMore()">
            <div class="get-care-now-show-more-button-mobile">{{showMoreText}}</div>
        </mat-card>
    </div>
</div>
<div *ngIf="!virtualUrgentCareOptions || virtualUrgentCareOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>
